<template>
  <instructions-component
    class="pointer-events-auto midder"
    :header="$t('instructions')"
    :button-text="$t('continue')"
    :cards="getInstructions"
    show-button
    @button-click="closeInstructions"
  />
</template>

<script lang="ts">
import { Instructions } from '@powerplay/core-minigames-ui'
import {
  CorePhases,
  corePhasesManager,
  modes,
  tutorialManager
} from '@powerplay/core-minigames'
import { pathAssets } from '@/globals/globalvariables'

import { defineComponent } from 'vue'
import { blurState } from '@/stores/blurState'

export default defineComponent({
  name: 'InstructionComponent',
  components: {
    InstructionsComponent: Instructions
  },
  props: {
    isMobile: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close-instructions'],
  computed: {
    getInstructions(): {imgSrc: string, header: string, text: string[]}[] {

      blurState().isActive = true

      if (modes.isTrainingMode()) {

        return [
          {
            imgSrc: `${pathAssets}/ui/instructions/training-1.png?3`,
            header: this.$t('instructionsDisciplineTraining8Cell1Title'),
            text: [this.$t('instructionsDisciplineTraining8Cell1Text1')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-2.png?3`,
            header: this.$t('instructionsDisciplineTraining8Cell2Title'),
            text: [this.$t('instructionsDisciplineTraining8Cell2Text1')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-3.png?3`,
            header: this.$t('instructionsDisciplineTraining8Cell3Title'),
            text: [this.$t('instructionsDisciplineTraining8Cell3Text1')]
          },
          {
            imgSrc: `${pathAssets}/ui/instructions/training-4.png?3`,
            header: this.$t('instructionsDisciplineTraining8Cell4Title'),
            text: [this.$t('instructionsDisciplineTraining8Cell4Text1')]
          }
        ]

      }

      const mobilePart = this.isMobile ? 'Mobile' : ''

      return [
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-1.png?4`,
          header: this.$t('instructionsDiscipline8Cell1Title'),
          text: [this.$t(`instructionsDiscipline8Cell1Text1${mobilePart}`)]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-2.png?4`,
          header: this.$t('instructionsDiscipline8Cell2Title'),
          text: [this.$t(`instructionsDiscipline8Cell2Text1${mobilePart}`)]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-3.png?4`,
          header: this.$t('instructionsDiscipline8Cell3Title'),
          text: [
            this.$t('instructionsDiscipline8Cell3Text1'),
            this.$t('instructionsDiscipline8Cell3Text2')
          ]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-4.png?4`,
          header: this.$t('instructionsDiscipline8Cell4Title'),
          text: [this.$t('instructionsDiscipline8Cell4Text1')]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-5.png?4`,
          header: this.$t('instructionsDiscipline8Cell5Title'),
          text: [this.$t('instructionsDiscipline8Cell5Text1')]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-6.png?4`,
          header: this.$t('instructionsDiscipline8Cell6Title'),
          text: [this.$t('instructionsDiscipline8Cell6Text1')]
        },
        {
          imgSrc: `${pathAssets}/ui/instructions/instructions-7.png?4`,
          header: this.$t('instructionsDiscipline8Cell7Title'),
          text: [this.$t('instructionsDiscipline8Cell7Text1')]
        },

      ]

    }
  },
  methods: {
    closeInstructions(): void {

      // pokial mame prvotne instrukcie, tak ich zavrieme
      if (corePhasesManager.isActivePhaseByType(CorePhases.instructions)) {

        corePhasesManager.getActualPhase()?.finishPhase()

      }
      this.$emit('close-instructions')
      tutorialManager.blockInputsManually()

    }
  }
})
</script>

<style lang="less" scoped></style>
